import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {zodValidator} from '@tanstack/zod-adapter'
import {z} from 'zod'
import {TodayPage} from '@/features/today/TodayPage'

export const defaultTodaySearch = {
	includeClosed: false,
}

// Same name/semantics as the board: off = Done scoped to the current cycle,
// on = all-time completions. Shared with /today-checkbox, which renders the
// same TodayPage component.
export const todaySearchSchema = z.object({
	includeClosed: z.boolean().default(false),
})

function TodayRoute() {
	const {includeClosed} = Route.useSearch()
	const navigate = Route.useNavigate()
	return (
		<TodayPage
			includeClosed={includeClosed}
			onIncludeClosedChange={(pressed) =>
				navigate({search: {includeClosed: pressed}, replace: true})
			}
		/>
	)
}

export const Route = createFileRoute('/today/')({
	component: TodayRoute,
	validateSearch: zodValidator(todaySearchSchema),
	search: {
		middlewares: [stripSearchParams(defaultTodaySearch)],
	},
})
